import { Preferences } from "@capacitor/preferences"

const STORAGE_KEY = "app_language"

export const supportedLanguages = ["ja", "en"] as const
export type SupportedLanguage = (typeof supportedLanguages)[number]

export const languageLabels: Record<SupportedLanguage, string> = {
    ja: "日本語",
    en: "English"
}

import { isPreferencesAvailable } from "./capacitorPreferences"

export const getStoredLanguage = async (): Promise<SupportedLanguage> => {
    if (!isPreferencesAvailable()) return "ja"
    const { value } = await Preferences.get({ key: STORAGE_KEY })
    if (value && supportedLanguages.includes(value as SupportedLanguage)) {
        return value as SupportedLanguage
    }
    return "ja"
}

export const setStoredLanguage = async (
    language: SupportedLanguage
): Promise<void> => {
    if (!isPreferencesAvailable()) return
    await Preferences.set({ key: STORAGE_KEY, value: language })
}
